import script from "./TheLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./TheLoader.vue?vue&type=script&setup=true&lang=js"

import "./TheLoader.vue?vue&type=style&index=0&id=4d8c96aa&lang=css"

const __exports__ = script;

export default __exports__